import React, { useEffect, useState } from "react";
import { Select, Table, Typography, Card, Row, Col, Tag } from "antd";

const { Title } = Typography;
const { Option } = Select;

function TeamMemberReports() {

  const [projects, setProjects] = useState([]);
  const [tasks, setTasks] = useState([]);

  const [selectedMember, setSelectedMember] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);

  const [filteredTasks, setFilteredTasks] = useState([]);

  // ✅ FETCH PROJECTS
  useEffect(() => {
    const token = localStorage.getItem("access-token");

    fetch("https://rhrmapi.up2dateinc.com/api/projects", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setProjects(Array.isArray(data) ? data : []));
  }, []);

  // ✅ FETCH TASKS
  useEffect(() => {
    const token = localStorage.getItem("access-token");

    fetch("https://rhrmapi.up2dateinc.com/api/tasks", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setTasks(Array.isArray(data) ? data : []));
  }, []);

  // ✅ FILTER LOGIC (FIXED FOR BACKEND)
  useEffect(() => {
    let result = tasks;

    if (selectedMember) {
      result = result.filter(
        t => t.assignee?.toLowerCase() === selectedMember.toLowerCase()
      );
    }

    if (selectedProject) {
      result = result.filter(
        t => t.projectId === selectedProject
      );
    }

    setFilteredTasks(result);

  }, [selectedMember, selectedProject, tasks]);

  // ✅ GET TEAM MEMBERS FROM PROJECTS
  const allMembers = [
    ...new Set(
      projects.flatMap(p =>
        p.teamMembers
          ? p.teamMembers.split(",").map(m => m.trim())
          : []
      )
    )
  ];

  // ✅ TABLE COLUMNS (UPDATED)
  const columns = [
    {
      title: "SL No",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Summary",
      dataIndex: "summary",
    },
    {
      title: "Sprint Name",
      dataIndex: "sprint",
    },
    {
      title: "Project Name",
      render: (_, record) =>
        projects.find(p => p._id === record.projectId)?.projectName || "-",
    },
    {
      title: "Project Lead",
      render: (_, record) =>
        projects.find(p => p._id === record.projectId)?.projectLead || "-",
    },
    {
      title: "Team Member",
      dataIndex: "assignee",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      render: (priority) => {
        const color =
          priority === "High"
            ? "red"
            : priority === "Medium"
            ? "orange"
            : "green";

        return <Tag color={color}>{priority}</Tag>;
      },
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (date) =>
        date ? new Date(date).toLocaleDateString() : "-",
    },
  ];

  return (
    <div style={{ padding: 20 }}>

      <Title level={3}>👥 Team Member Reports</Title>

      {/* FILTERS */}
      <Row gutter={16} style={{ marginBottom: 20 }}>

        <Col span={8}>
          <Card title="Select Team Member">
            <Select
              style={{ width: "100%" }}
              placeholder="Choose member"
              onChange={setSelectedMember}
              allowClear
            >
              {allMembers.map((m, i) => (
                <Option key={i} value={m}>{m}</Option>
              ))}
            </Select>
          </Card>
        </Col>

        <Col span={8}>
          <Card title="Select Project">
            <Select
              style={{ width: "100%" }}
              placeholder="Choose project"
              onChange={setSelectedProject}
              allowClear
            >
              {projects.map(p => (
                <Option key={p._id} value={p._id}>
                  {p.projectName}
                </Option>
              ))}
            </Select>
          </Card>
        </Col>

      </Row>

      {/* ✅ DYNAMIC TITLE */}
      {selectedMember && selectedProject && (
        <Title level={4}>
          All Tasks for <b>{selectedMember}</b> from{" "}
          <b>
            {
              projects.find(p => p._id === selectedProject)?.projectName
            }
          </b>
        </Title>
      )}

      {/* TASK TABLE */}
      <Card style={{ marginTop: 20 }}>
        <Table
          rowKey="_id"
          columns={columns}
          dataSource={filteredTasks}
          pagination={{ pageSize: 5 }}
        />
      </Card>

    </div>
  );
}

export default TeamMemberReports;